import { lazy } from "react";

const GroupPermission = lazy(() => import("./Group"));

const SlipPermission = lazy(() => import("./Slip"));

const ConfigurationPermission = lazy(() => import("./Configuration"));

const ApprovalConfiguration = lazy(() => import("./Approval"));

export {
  ApprovalConfiguration,
  ConfigurationPermission,
  GroupPermission,
  SlipPermission,
};
